<template>
  <v-layout
    v-if="$route.name === 'blog.posts'"
    row
    wrap
  >
    <v-flex>
      <page-tile-title :has-back-button="true">
        <v-btn
          color="primary"
          :disabled="categories.length === 0"
          @click="$router.push({ name: 'blog.posts.create' })"
        >
          <v-icon left>
            add
          </v-icon>
          Create Post
        </v-btn>
      </page-tile-title>
      <!-- end page-tile-title -->

      <v-layout
        v-if="categories.length === 0"
        my-3
      >
        <v-flex>
          <v-alert
            :value="categories.length === 0"
            type="error"
          >
            Please create category first before creating a post
          </v-alert>
        </v-flex>
      </v-layout>
      <!-- alert here -->

      <v-layout my-3>
        <v-flex>
          <v-card>
            <v-data-table
              :items="items"
              :headers="headers"
              :loading="isLoading"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :total-items="totalItems"
              :disable-initial-sort="true"
            >
              <template v-slot:items="props">
                <td>
                  <v-btn
                    flat
                    small
                    @click="onRouteToView(props.item.slug)"
                  >
                    {{ props.item.title }}
                  </v-btn>
                </td>
                <td>
                  <v-chip
                    label
                    small
                    dark
                    :color="props.item.publish ? 'success' : 'error'"
                  >
                    {{ props.item.publish ? 'Published' : 'Draft' }}
                  </v-chip>
                </td>
                <td v-text="props.item.category" />
                <td v-text="props.item.created_by" />
                <td v-text="formatDate(props.item.created_at)" />
                <td>
                  {{ props.item.published_at ? formatDate(props.item.published_at) : 'N/A' }}
                </td>
                <td>
                  <!-- buttons here -->
                  <v-layout align-center>
                    <delete-dialog :item="props.item" />
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- end flex -->
  </v-layout>
  <!-- end layout -->

  <router-view v-else />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { fromThisDate } from '@/helpers/utilities'
import PageTileTitle from '@/components/Utilities/PageTileTitle'
import DeleteDialog from './components/DeleteDialog'
export default {
  components: {
    PageTileTitle,
    DeleteDialog
  },
  data: () => ({
    headers: [
      {
        text: 'Title',
        sortable: false,
        value: 'title',
        width: '400px',
        fixed: true
      },
      {
        text: 'Publish',
        sortable: false,
        value: 'publish',
        width: '200px'
      },
      {
        text: 'Category',
        sortable: false,
        value: 'category',
        width: '300px'
      },
      {
        text: 'Created By',
        sortable: false,
        value: 'created_by',
        width: '300px'
      },
      {
        text: 'Created At',
        sortable: false,
        value: 'created_at',
        width: '300px'
      },
      {
        text: 'Published At',
        sortable: false,
        value: 'published_at',
        width: '300px'
      },
      {
        text: 'Action',
        sortable: false,
        value: false,
        width: '300px'
      }
    ]
  }),
  computed: {
    ...mapGetters({
      isLoading: 'blogPosts/isLoading',
      items: 'blogPosts/posts',
      categories: 'blogCategories/categories',
      tags: 'blogTags/tags',
      galleries: 'blogGallery/galleries',
      rowsPerPageItems: 'blogPosts/rowPerPageItems',
      paginations: 'blogPosts/pagination'
    }),
    ...mapState({
      totalItems: state => state.blogPosts.totalItems,
    }),
    pagination: {
      get: function () {
        return this.paginations
      },
      set: function (value) {
        this.getPosts(value)
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getPosts(this.page)
      },
      update () {
        this.getPosts(this.page)
      },
      deep: true
    }
  },
  created () {
    if (this.categories.length === 0) {
      this.getCategories({
        page: 1,
        rowsPerPage: 10
      })
    }
    if (this.tags.length === 0) {
      this.getTags({
        page: 1,
        rowsPerPage: 10
      })
    }
    if (this.galleries.length === 0) {
      this.getGalleries()
    }
  },
  methods: {
    ...mapActions({
      getPosts: 'blogPosts/getPosts',
      getCategories: 'blogCategories/getCategories',
      getTags: 'blogTags/getTags',
      getGalleries: 'blogGallery/getGalleries'
    }),
    formatDate (date) {
      return fromThisDate(date)
    },
    onRouteToView (slug) {
      this.$router.push({
        name: 'blog.posts.view',
        params: {
          slug: slug
        }
      })
    }
  }
}
</script>

<style>
.v-table__overflow {
  overflow-x: scroll;
}
</style>
